import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';
import { submitFormSubmission } from '../../services/formSubmissionsApi';

var defaultBannerImg = require('./../../images/banner/9.jpg');
var separatorBg = require('./../../images/background/cross-line2.png');
var infoBg = require('./../../images/background/bg-map.png');

class ContactUs extends React.Component {
    static contextType = SiteContentContext;

    constructor(props) {
        super(props);
        this.state = {
            form: {
                username: '',
                email: '',
                phone: '',
                message: '',
            },
            isSubmitting: false,
            submitError: '',
            submitSuccess: '',
        };
    }

    handleFormChange = (event) => {
        const { name, value } = event.target;
        this.setState((prev) => ({
            ...prev,
            form: {
                ...prev.form,
                [name]: value,
            },
        }));
    };

    handleFormSubmit = async (event) => {
        event.preventDefault();
        const { form, isSubmitting } = this.state;
        if (isSubmitting) {
            return;
        }

        this.setState({ isSubmitting: true, submitError: '', submitSuccess: '' });

        try {
            await submitFormSubmission({
                source: 'contact-page',
                page: '/iletisim',
                name: form.username,
                email: form.email,
                phone: form.phone,
                message: form.message,
            });

            this.setState({
                isSubmitting: false,
                submitError: '',
                submitSuccess: 'Mesajınız alındı. En kısa sürede dönüş yapacağız.',
                form: {
                    username: '',
                    email: '',
                    phone: '',
                    message: '',
                },
            });
        } catch (error) {
            this.setState({
                isSubmitting: false,
                submitSuccess: '',
                submitError: error?.message || 'Gönderim sırasında bir hata oluştu.',
            });
        }
    };

    render() {
        const { form, isSubmitting, submitError, submitSuccess } = this.state;
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const pageTexts = t?.pages?.contact || {};
        const formTexts = pageTexts?.form || {};
        const infoTexts = pageTexts?.info || {};
        const contact = getByPath(content, 'contact', {});
        const phones = Array.isArray(contact.phones) ? contact.phones : [];
        const addressLines = Array.isArray(contact.addressLines) ? contact.addressLines : [];

        const bannerImg = resolveMediaSrc(getByPath(content, 'media.pages.contactBanner', ''), defaultBannerImg);

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        className="contact-banner single-line-banner"
                        title={pageTexts?.banner?.title || 'İletişim'}
                        pagename={pageTexts?.banner?.pageName || 'İletişim'}
                        description={pageTexts?.banner?.description || ''}
                        bgimage={bannerImg}
                    />
                    <div className="section-full p-tb80 inner-page-padding contact-page-section">
                        <div className="container">
                            <div className="section-content">
                                <div className="row">
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        <form className="contact-form cons-contact-form bg-gray p-a30 contact-page-form" method="post" action="#" onSubmit={this.handleFormSubmit}>
                                            <div className="contact-one">
                                                <div className="section-head">
                                                    <div className="sx-separator-outer separator-left">
                                                        <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + separatorBg + ')' }}>
                                                            <h3 className="sep-line-one">{formTexts.title || 'İletişim Formu'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <input name="username" type="text" required className="form-control" placeholder={formTexts?.fields?.name || ''} value={form.username} onChange={this.handleFormChange} />
                                                </div>
                                                <div className="form-group">
                                                    <input name="email" type="text" className="form-control" required placeholder={formTexts?.fields?.email || ''} value={form.email} onChange={this.handleFormChange} />
                                                </div>
                                                <div className="form-group">
                                                    <input name="phone" type="text" className="form-control" placeholder={formTexts?.fields?.phone || ''} value={form.phone} onChange={this.handleFormChange} />
                                                </div>
                                                <div className="form-group">
                                                    <textarea name="message" rows={4} className="form-control" required placeholder={formTexts?.fields?.message || ''} value={form.message} onChange={this.handleFormChange} />
                                                </div>
                                                <div className="text-right">
                                                    <button name="submit" type="submit" value="Submit" className="site-button btn-half" disabled={isSubmitting}>
                                                        <span>{isSubmitting ? 'Gönderiliyor...' : (formTexts.submitLabel || 'Gönder')}</span>
                                                    </button>
                                                </div>
                                                {submitSuccess ? <p className="m-t10" style={{ color: '#2f8f2f' }}>{submitSuccess}</p> : null}
                                                {submitError ? <p className="m-t10" style={{ color: '#c9302c' }}>{submitError}</p> : null}
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="contact-info block-shadow bg-white bg-center p-a40 contact-page-info" style={{ backgroundImage: 'url(' + infoBg + ')' }}>
                                            <div>
                                                <div className="section-head">
                                                    <div className="sx-separator-outer separator-left">
                                                        <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + separatorBg + ')' }}>
                                                            <h3 className="sep-line-one">{infoTexts.title || 'İletişim Bilgileri'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sx-icon-box-wraper left p-b30">
                                                    <div className="icon-xs"><i className="fa fa-map-marker" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0">{infoTexts.addressTitle || 'Adres'}</h5>
                                                        <p>{addressLines.map((line, index) => <React.Fragment key={`addr-${index}`}>{line}{index < addressLines.length - 1 ? <br /> : null}</React.Fragment>)}</p>
                                                    </div>
                                                </div>
                                                <div className="sx-icon-box-wraper left p-b30">
                                                    <div className="icon-xs"><i className="fa fa-clock-o" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0">{infoTexts.workingHoursTitle || 'Çalışma Saatleri'}</h5>
                                                        <p>{contact?.workingHours?.weekdays}<br />{contact?.workingHours?.sunday}</p>
                                                    </div>
                                                </div>
                                                <div className="sx-icon-box-wraper left p-b30">
                                                    <div className="icon-xs"><i className="fa fa-envelope" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0">{infoTexts.emailTitle || 'E-Mail'}</h5>
                                                        <p>{contact.email}</p>
                                                    </div>
                                                </div>
                                                <div className="sx-icon-box-wraper left">
                                                    <div className="icon-xs"><i className="fa fa-phone" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0">{infoTexts.phoneTitle || 'Telefon'}</h5>
                                                        <p>
                                                            {phones.map((phone, index) => (
                                                                <React.Fragment key={`phone-${index}`}>
                                                                    {(infoTexts.phonePrefix || 'Tel :')} {phone}
                                                                    {index < phones.length - 1 ? <br /> : null}
                                                                </React.Fragment>
                                                            ))}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gmap-outline contact-page-map">
                        <iframe
                            title="Firat Celik Kapi Konum"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1300.0771978745506!2d29.24104058177765!3d40.98769193974887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac6a8ac98938f%3A0x9d221f981819edc6!2zRklSQVQgw4dFTMSwSyBLQVBJIMOcUkVUxLBN!5e1!3m2!1str!2str!4v1772573928046!5m2!1str!2str"
                            width="600"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
                <Footer />
            </>
        );
    };
};

export default ContactUs;
